import type { ComponentType } from "react";
import type { Variante } from "./Kpi";
import { TelaClientes } from "./TelaClientes";
import { TelaCs } from "./TelaCs";
import { TelaGeral } from "./TelaGeral";
import { TelaSistema } from "./TelaSistema";

export interface Tela {
  /** Vai na URL (?tela=) da Home e da TV. */
  id: string;
  titulo: string;
  Componente: ComponentType<{ variante: Variante }>;
  /** Na TV, as últimas interações vão na coluna lateral deste slide. */
  comInteracoes?: boolean;
}

/** Fonte única das telas: as abas da Home e os slides "Silpi Sistema" da TV, na mesma ordem. */
export const TELAS: Tela[] = [
  { id: "geral", titulo: "Geral", Componente: TelaGeral },
  { id: "cs", titulo: "CS", Componente: TelaCs, comInteracoes: true },
  { id: "clientes", titulo: "Clientes", Componente: TelaClientes },
  { id: "sistema", titulo: "Sistema", Componente: TelaSistema },
];

/** Índice da tela pelo id da URL; desconhecido ou ausente cai na primeira. */
export function indiceDaTela(id: string | null): number {
  return Math.max(0, TELAS.findIndex((t) => t.id === id));
}
